/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {plaidBankLinking} from '../api'

export const useMutationPlaidBankLinking = createReactQueryMutationHook('plaidBankLinking', plaidBankLinking)
